messageBox = {};

messageBox.setValue = function (value) {
  messageBox.messageText.setText(value);
};

messageBox.setMessage = function (text, translationParams, value, symbolIndex) {
  var args = [];
  if (checkForDefined(translationParams)) {
    for (var i = 1; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
  }
  messageBox.messageText.setTranslationPhrase(text);
  messageBox.messageText.setTranslationParameters.apply(messageBox.messageText, args);
};

messageBox.show = function (canShow) {
  messageBox.backgroundParent.visible = canShow;
};

messageBox.clearMessage = function () {
  messageBox.messageText.setText('');
  //messageBox.background.position.y = 105;
};

messageBox.create = function (json) {
  return new PIXI.Container();
};

messageBox.riseFromToDeep = function () {};

messageBox.initialise = function (json, container, resources) {
  messageBox.backgroundParent = resourceManager.createObject('container', 'parent', container.name);
  messageBox.background = resourceManager.createObject('container', 'background', messageBox.backgroundParent.name, {
    fileName: '',
    anchor: 0.5,
    y: -80,
  });

  messageBox.messageText = resourceManager.createObject('text', 'messageText', messageBox.background, {
    fontDefinition: 'popUpFontWhite',
    fontSize: 20,
    text: '',
    anchor: 0.5,
    x: -15,
    y: -12,
    maxWidth: 175,
  });

  messageBox.backgroundParent.visible = false;
};

messageBox.getFilesRequired = function (json) {
  return ['UserInterface/UIBlank.png'];
};

resourceManager.registerObjectType('messageBox', messageBox.create, messageBox.initialise, messageBox.getFilesRequired);
